
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1.58 45.64h56.84V58.5H1.58zM39.72 45.7v12.58M20.28 58.28V45.7M10.04 45.85v12.62M49.96 45.85v12.62M44.31 40.31a22 22 0 10-28.74-.11M6.85 45.55l8.6-5.21h29.1l8.6 5.21M8.5 22.32h43"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-linejoin":"round","stroke-width":"2","d":"M31.06 40.49l9.18-18.71M19.76 21.78l9.01 18.36M29.52 1.87l-9.76 19.91M40.24 21.78L30.49 1.89M40.24 21.78l7.42 15.12M46.44 9.14l-6.2 12.64M12.33 36.93l7.43-15.15M19.76 21.78L13.47 8.96"}})])
          )
        }
      }
    